module.exports = __webpack_public_path__ + "img/5.8be3e92f.png";